import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useUpdateMessagesInViewportHandlerPresenter } from './UpdateMessagesInViewportHandler.presenter';

export const UpdateMessagesInViewportHandler: FC = observer(() => {
  useUpdateMessagesInViewportHandlerPresenter();

  return null;
});
